export const TEMPLATE = {
	SLOT: Symbol('template ad slot'),
	NAME: Symbol('template name'),
	PARAMS: Symbol('template params'),
};
